export default String.raw`
{% comment -%}<!-- Attributes -->{% endcomment -%}
<div class="product-attributes product-attributes-js">
	<h2>{{ translations.Specification }}</h2>
	<ul class="attributes-column attributes-list-js">
		{% if activeProduct.VAT != '' -%}
			<li>
				<div class="name">{{ translations.VatTax }}:</div>
				<div class="value">{{ activeProduct.VAT }}%</div>
			</li>
		{% endif -%}
		{% if activeProduct.Weight != '' and activeProduct.Weight > 0 -%}
			<li>
				<div class="name">{{ translations.Weight }}:</div>
				<div class="value weight-value-js">{{ activeProduct.Weight | Normalize | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: 4 }}{{ translations.Kg }}</div>
			</li>
		{% endif -%}
		{% if activeProduct.NetWeight != '' and activeProduct.NetWeight > 0 -%}
			<li>
				<div class="name">{{ translations.NetWeight }}:</div>
				<div class="value netweight-value-js">{{ activeProduct.NetWeight | Normalize | DividedBy: product.BasicUnitRatio | Times: unitRatio | Round: 4 }}{{ translations.Kg }}</div>
			</li>
		{% endif -%}
		{% if activeProduct.WasteMgmtCost != 0 and activeProduct.WasteMgmtCost != ''-%}
			<li>
				<div class="name">{{ translations.WasteMgmtCost }}:</div>
				<div class="value">{{ activeProduct.WasteMgmtCost | Normalize }} {{ currencyExt }}</div>
			</li>
		{% endif -%}
		{% if settings.eanCodes == 'eanCodes-yes' -%}
			{% assign totalEanCount = eanCodes.size -%}
			{% if activeProduct.UPC != '' or eanCodesStringOutput != '' -%}
				<li>
					{% if activeProduct.UPC != '' -%}
						{% if eanCodesStringOutput != '' -%}
							<div class="name multiple-ean-js">{{ translations.EanCodes }}:</div>
							<div class="name hidden-js one-ean-js">{{ translations.EanCode }}:</div>
						{% else -%}
							<div class="name hidden-js multiple-ean-js">{{ translations.EanCodes }}:</div>
							<div class="name one-ean-js">{{ translations.EanCode }}:</div>
						{% endif -%}
					{% else -%}
						{% if unitSpecificEanCount == 1 -%}
							<div class="name one-ean-js">{{ translations.EanCode }}:</div>
							<div class="name hidden-js multiple-ean-js">{{ translations.EanCodes }}:</div>
						{% else -%}
							<div class="name hidden-js one-ean-js">{{ translations.EanCode }}:</div>
							<div class="name multiple-ean-js">{{ translations.EanCodes }}:</div>
						{% endif -%}
					{% endif -%}
			
					<div class="value ean-js">
						{% if activeProduct.UPC != '' -%}
							{{ activeProduct.UPC }}{% if eanCodesStringOutput != '' -%},<br>{{ eanCodesStringOutput }}{% endif -%}
						{% else -%}
							{{ eanCodesStringOutput }}
						{% endif -%}
					</div>
				</li>
			{% endif -%}
		{% else -%}
			{% if activeProduct.UPC != '' -%}
				<li>
					<div class="name">{{ translations.EanCode }}:</div>
					<div class="value">{{ activeProduct.UPC }}</div>
				</li>
			{% endif -%}
		{% endif -%}
		{% if product.ManufacturerCode != '' -%}
			<li>
				<div class="name">{{ translations.ManufacturerCode }}:</div>
				<div class="value">{{ product.ManufacturerCode }}</div>
			</li>
		{% endif -%}
		{% if product.CN != '' -%}
			<li>
				<div class="name">{{ translations.CnCode }}:</div>
				<div class="value">{{ product.CN }}</div>
			</li>
		{% endif -%}
		{% if activeProduct.Symbol != '' -%}
			<li>
				<div class="name">{{ translations.Symbol }}:</div>
				<div class="value">{{ activeProduct.Symbol }}</div>
			</li>
		{% endif -%}
		{% for attribute in activeProduct.Attributes-%}
			{% assign is360AttrSet = false -%}
			{% assign hideAttr = false -%}
			{% assign attributeName = attribute.Name | Downcase -%}
			{% if attributeName contains '360photo' and is360AttrSet == false -%}
				{% assign hideAttr = true -%}
				{% assign is360AttrSet = true -%}
				<input type="hidden" id="photoLink" value="{{attribute.Value}}">
			{% endif -%}

			{% if hideAttr == false -%}
				<li>
					<div class="name">{{ attribute.Name }}:</div>
					<div class="value">
						{% if attribute.Format == 2 and attribute.Value contains '.' -%}
							{% assign valueSize = attribute.Value | Size -%}
							{% assign normalizedValue = attribute.Value -%}
							{% for character in (1..valueSize) -%}
								{% assign last = normalizedValue | Last -%}
								{% if last == '0' or last == '.' -%}
									{% assign toCut = normalizedValue | Size | Minus: 1 -%}
									{% assign normalizedValue = normalizedValue | Truncate: toCut,'' -%}
								{% endif -%}
								{% if last == '.' -%}
									{% break -%}
								{% endif -%}
							{% endfor -%}
							{{ normalizedValue }}
						{% else -%}
							{{ attribute.Value }}
						{% endif -%}
					</div>
				</li>
			{% endif -%}
		{% endfor -%}
		<li class="dimensions-height-js {% if unitDimensions == null or unitDimensions.Height == 0 -%} hidden-js {% endif -%}">
			<div class="name">{{ translations.Height }}:</div>
			<div class="value height-value-js">{{unitDimensions.Height }} cm</div>
		</li>
		<li class="dimensions-length-js {% if unitDimensions == null or unitDimensions.Length == 0 -%} hidden-js {% endif -%}">
			<div class="name">{{ translations.Length }}:</div>
			<div class="value length-value-js">{{unitDimensions.Length}} cm</div>
		</li>
		<li class="dimensions-width-js {% if unitDimensions == null or unitDimensions.Width == 0 -%} hidden-js {% endif -%}">
			<div class="name">{{ translations.Width }}:</div>
			<div class="value width-value-js">{{unitDimensions.Width}} cm</div>
		</li>  
	</ul>

	<script>
		if ($('#photoLink').index() >= 0 || $('#parentPhotoLink').index() >= 0) {
			$('.open360').removeClass('hidden-js');
		} else {
			$('.open360').addClass('hidden-js');
		}

		if ($('.product-presentation-js').index() >= 0 && $('.installmentCalculator').index() >= 0) {
			reloadInstallmentButtons(1);
		}
	</script>
</div>

{% comment -%}<!-- Description -->{% endcomment -%}
{% if product.Description != "" -%}
	<div class="product-description product-description-js">
		<h2>{{ translations.ProductDescription }}</h2>
		<div>{{ product.Description }}</div>
		{% if product.AiGeneratedDescription -%}
			<div class="ai-generated-content">{{ translations.AiGeneratedDescription }}</div>
		{% endif -%}
	</div>
{% endif -%}

{% comment -%}<!-- GPSR  -->{% endcomment -%}
{% if showManufacturer or showResponsiblePerson -%}
	<div class="gpsr-container-js">
		<h2>{{ translations.ProductResponsibleEntity }}</h2>
		<div class="gpsr {% if showResponsiblePerson or showManufacturer %}{% if showResponsiblePerson and showManufacturer %}{% else %}grid-view{% endif %}{% endif %}">
			{% if showManufacturer -%}
				{% assign manufacturer = activeProduct.ResponsibleProducer -%}
				<div>
					<h3>{{translations.Manufacturer}}</h3>
					<ul class="attributes-column {% unless showResponsiblePerson %}single-view{% endunless %} product-gpsr-js attributes-list-js">
						<li>
							<div class="name">{{translations.Manufacturer}}:</div>
							<div class="value">{{manufacturer.Name}}</div>
						</li>
						<li>
							<div class="name">{{translations.Address}}:</div>
							<div class="value">{{manufacturer.Street}} {{manufacturer.HouseNo}}{% if manufacturer.FlatNo != ''-%}/{%endif-%}{{manufacturer.FlatNo}}</div>
						</li>
						<li>
							<div class="name">{{translations.City}}:</div>
							<div class="value">{{manufacturer.PostalCode}} {{manufacturer.City}}</div>
						</li>
						<li>
							<div class="name">{{translations.Country}}:</div>
							<div class="value">{{manufacturer.Country}}</div>
						</li>
						<li>
							<div class="name">{{translations.Contact}}:</div>
							<div class="value">{{manufacturer.Email}}</div>
						</li>
					</ul>
				</div>
			{% endif -%}
			{% if showResponsiblePerson -%}
			{% assign responsiblePerson = activeProduct.ResponsiblePerson -%}
				<div>
					<h3>{{translations.ProductResponsiblePerson}}</h3>
					<ul class="attributes-column {% unless showManufacturer %}single-view{% endunless %} product-gpsr-js attributes-list-js">
						<li>
							<div class="name">{{translations.NameAndSurname}}:</div>
							<div class="value">{{responsiblePerson.Name}}</div>
						</li>
						<li>
							<div class="name">{{translations.Address}}:</div>
							<div class="value">{{responsiblePerson.Street}} {{responsiblePerson.HouseNo}}{% if responsiblePerson.FlatNo != ''-%}/{%endif-%}{{responsiblePerson.FlatNo}}</div>
						</li>
						<li>
							<div class="name">{{translations.City}}:</div>
							<div class="value">{{responsiblePerson.PostalCode}} {{responsiblePerson.City}}</div>
						</li>
						<li>
							<div class="name">{{translations.Country}}:</div>
							<div class="value">{{responsiblePerson.Country}}</div>
						</li>
						<li>
							<div class="name">{{translations.Contact}}:</div>
							<div class="value">{{responsiblePerson.Email}}</div>
						</li>
					</ul>
				</div>
			{% endif -%}
		</div>
	</div>
{% endif -%}

{% comment -%}<!-- Attachments  -->{% endcomment -%}
{% if product.Attachments[0] -%}
	<div class="downloads downloads-js">
		<h2>{{ translations.Downloads }}</h2>
		<ul class="attachements attributes-list-js">
			{% for file in product.Attachments -%}
				{% if file.Url != "" -%}

					{% capture fileExtension -%}.{{file.Extension | Downcase}}{% endcapture -%}

					{% if file.Name contains '.' -%}
						{% capture fileExtensionFromName -%}.{{file.Name | Downcase | Split: '.' | Last}}{% endcapture -%}
						{% if fileExtensionFromName == fileExtension -%}
							{% assign fileName = file.Name -%}
						{% else -%}
							{% capture fileName -%}{{file.Name}}{{fileExtension}}{% endcapture -%}
						{% endif -%}
					{% else -%}
							{% capture fileName -%}{{file.Name}}{{fileExtension}}{% endcapture -%}
					{% endif -%}

					<li>
						{% capture fileHref -%}{% include 'partials/common/user-link.html', userLink: file.Url -%}{% endcapture -%}
						<a href="{{ fileHref }}" target="_blank" title="{{ file.Title | H }}" {% if file.NoFollow -%} rel="nofollow" {% endif -%}>				
							<svg height="24" width="24" class="svgIcon">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#file-alt-{{settings.iconStyle}}"></use>
							</svg> 
							<span>{{fileName}} {% if file.Size -%}({{file.Size | DividedBy: 1024}} KB){% endif -%}</span>
						</a>
					</li>
				{% endif -%}
			{% endfor -%}
		</ul>
	</div>
{% endif -%}

{% comment -%}<!-- Reviews  -->{% endcomment -%}
{% if config.Reviews.Enabled -%}
	<div class="reviews-container reviews-js">
		{% if config.Reviews.AuthenticationRequired == true and customer.Authenticated == true -%}
			{% assign canAddReview = true -%}
		{% endif -%}
		<h2 class="reviews-title">{{ translations.Reviews }}</h2>
		<div class="reviews-container__header">
			{% if product.RatingCount > 0 -%}
				<div class="review-overall reviews-rating-js">
					<div class="all-opinions">{{ product.Rating | Round: 1 }}/5 <span>({{ translations.Reviews }}: {{ product.RatingCount }})</span></div>
					<div class="stars">
					{% assign productRating = product.Rating | Round: 1 %}
					{% for i in (1..5) %}
						{% assign starIndex= i %}
						{% assign threshold = starIndex | Round: 2 | Minus: 0.5 %}
						{% if productRating >= starIndex %}
						<svg width="32" height="32">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-solid"></use>
						</svg>
						{% elsif productRating >= threshold %}
						<svg width="32" height="32">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-half-solid"></use>
						</svg>
						{% else %}
						<svg width="32" height="32">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-regular"></use>
						</svg>
						{% endif %}
					{% endfor %}
					</div>
				</div>
			{% else -%}
				<div class="no-reviews">
					<span>{{ translations.NoReviews }}</span>
					<div class="rating">
						{% assign reversedReviews = config.Reviews.Reviews | Skip: 1 | Reverse -%}
						{% for rating in reversedReviews -%}
							<svg class="stars" data-rating="{{rating.Rate}}">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-solid"></use>
							</svg>
						{% endfor -%}
					</div>
				</div>
			{% endif -%}
			<div class="reviews-container__header-subsection">		
				{% assign reviews = feedback.Reviews -%}
				<div class="reviews-summary">
					<div class="reviews-summary__star-details">
						{% assign totalReviews = feedback.TotalItems -%}
						{% assign reviewsCounter = feedback.ReviewsSummary -%}
					
						{% for rating in (1..5) reversed -%}
							{% assign count = 0 -%}

							{% for item in reviewsCounter -%}
									{% if item.Rating == rating -%}
										{% assign count = item.Count -%}
									{% endif %}
							{% endfor %}
					
							{% if totalReviews > 0 -%}
								{% assign percentage = count | Times: 100 | DividedBy: totalReviews -%}
							{% else %}
								{% assign percentage = 0 -%}
							{% endif %}
					
							<div class="review-bar">
								<svg width="16" height="16">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-solid"></use>
								</svg>
								<div class="review-bar__number">{{ rating }}</div>
								<progress max="100" value="{{ percentage }}"></progress>
								<span>{{ translations.Reviews }}: {{ count }}</span>
							</div>
						{% endfor -%}
					</div>
				</div>

				<div class="reviews-container__content">
					{% assign reviews = feedback.Reviews -%}
					<div class="reviews {% if config.Reviews.AuthenticationRequired and customer.Authenticated == false -%} not-auth {% else -%} auth {% endif -%}">
						{% if config.Reviews.AuthenticationRequired and customer.Authenticated == false -%}
							<svg width="32" height="32">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#lock-alt-{{settings.iconStyle}}"></use>
							</svg>
							<span class="description">
								{{ translations.SignedInOnlyReview }}
								<span class="login-to-add-review">            
									<a href="{{ page.BaseHref }}{{ config.DefinedPages.Login.Url }}" title="{{ translations.LogIn }}" style="font-weight: 600;">{{ translations.LogIn }}</a>, {{ translations.SignInToAddReview }}
								</span>
							</span>
						{% endif -%}
						{% if config.Reviews.AuthenticationRequired == false or canAddReview -%}
							<div class="description">
								<svg width="32" height="32">
									<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#edit-{{settings.iconStyle}}"></use>
								</svg>
								<span>{{ translations.HaveThatProductReview }}</span>
							</div>
							<button class="secondary-action-button open-add-review-form-js show-add-review-popup-js">{{ translations.AddReview }}</button>
						{% endif -%}
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="reviews-container__content {% if reviews[0] -%} reviews-list-js {% else -%} no-reviews-js {% endif -%}">
		{% include 'partials/product/reviews-list.html' -%}
	</div>
{% endif -%}

{% comment -%}<!-- Reviews popup  -->{% endcomment -%}
{% if config.Reviews.AuthenticationRequired == false or canAddReview -%}
	<div class="form-js adding-review-form-js hidden-js closable-popup-js">
		<input type="hidden" name="__action" value="Product/ReviewAdd">
		<input type="hidden" name="productId" value="{{ product.Id }}">
		<dialog class="dialog add-review-popup-js">
			<div class="dialog__header">
				<h2 class="dialog__header-title">{{ translations.AddReview }}</h2>
				<button class="close-button close-js clear-review-popup-js" aria-label="{{ translations.Close }}">
					<svg aria-hidden="true" width="24" height="24" class="svgIcon">
						<use xlink:href="css/img/fontawesome-icons.svg?v={{lqTS}}#times-{{settings.iconStyle}}"></use>
					</svg>
				</button>
			</div>
			<div class="dialog__content add-review">
				<div class="product-container">
					{% if activeProduct.Image -%}
						<div class="image">
							{{ activeProduct | Img: 'thumb' }}
						</div>
					{% else -%}
						<svg class="no-image">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#image-{{settings.iconStyle}}"></use>
						</svg>
					{% endif -%}
					<div class="info">
						<div class="name">
							{% if product.Url -%}
								<a href="{{ page.BaseHref }}{{ product.Url }}">
							{% endif -%}
							{% if type == 'set-return' -%}
								{{ product.SetName }}
							{% else -%}
								{{ product.NameNoHtml }}
							{% endif -%}
							{% if product.Url -%}
								</a>
							{% endif -%}
						</div>
					</div>
				</div>
				<h3><span class="required">* </span>{{ translations.YourRating }}</h3>
				<input type="hidden" name="rating" value="0">
				<div class="review-content">
					<div class="rating">
						{% assign reversedReviews = config.Reviews.Reviews | Skip: 1 | Reverse -%}
						{% for rating in reversedReviews -%}
							<svg tabindex="0" role="button" class="stars choose-rating-js" data-rating="{{rating.Rate}}" aria-label="{{ translations.GiveRate }}: {{ rating.Text }}">
								<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#star-solid"></use>
							</svg>
						{% endfor -%}
					</div>
					<div class="write-review">{{ translations.WriteAboutReview }}</div>
					<div class="form__input-wrapper">
						<label for="author" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Signature }}</label>
						<input class="form__input-value input-value-js" type="text" id="author" name="author" {% if customer.Authenticated == true -%}{% if customer.ReviewAuthor != "" -%} value="{{ customer.ReviewAuthor | H }}" {% else -%} value="{{ customer.Address.Name | H }}" {% endif -%}{% endif -%} required maxlength="50" >
						<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillSignature }}</div>
					</div>
					<div class="form__input-wrapper textarea">
						{% assign maxLength = 3500 -%}
						<label for="comment-textarea" class="form__input-info input-info-js"><span class="required">* </span>{{ translations.Comment }}</label>
						<div class="scrollable"></div>
						<textarea id="comment-textarea" class="form__input-value input-value-js" maxlength="3500" aria-label="{{ translations.Comment }}" name="comment" required></textarea>
						<div class="characters-counter characters-counter-js"></div>
						<div class="form__invalid-input validation-info-js validation-required-js hidden-js">{{ translations.FillReviewContent }}</div>
					</div>
					<div class="required-fields"><span class='required'>*</span> {{ translations.RequiredFields }}</div>
					<div class="required-fields" style="font-size: 14px;">
						{% capture terms -%}<a href="{{ page.BaseHref }}{{ config.DefinedPages.Terms.Url }}" rel="nofollow" target="_blank">{{ translations.ShopTerms }}</a>{% endcapture -%}
						{% capture privacy -%}<a href="{{ page.BaseHref }}{{ config.DefinedPages.Privacy.Url }}" rel="nofollow" target="_blank">{{ translations.PrivacyPolicy }}</a>{% endcapture -%}
						{{ translations.AddReviewConsentsInfo | Format: terms, privacy }}
					</div>
				</div>
				<div class="add-opinion">
					<button class="primary-action-button add-review-js">{{ translations.AddReview }}
						<svg width="24" height="24">
							<use href="css/img/fontawesome-icons.svg?v={{lqTS}}#plus-{{settings.iconStyle}}"></use>
						</svg>
					</button>
				</div>
			</div>
		</dialog>
	</div>
{% endif -%}
`